import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Eye, Share2, Home } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';

const Completion = () => {
  const navigate = useNavigate();
  const { currentRequest } = useAuthStore();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Content */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md mx-auto text-center">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            You're all done!
          </h1>

          <p className="text-gray-600 mb-8">
            Your verification has been submitted to{' '}
            <span className="font-medium text-gray-900">{currentRequest?.firmName || 'the firm'}</span>.
            You'll be notified once it's reviewed.
          </p>

          <div className="bg-white rounded-xl p-6 shadow-sm mb-8 text-left">
            <h3 className="font-medium text-gray-900 mb-4">What was shared</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-sm text-gray-600">
                <CheckCircle className="w-4 h-4 text-green-500 mr-3" />
                Identity document
              </li>
              <li className="flex items-center text-sm text-gray-600">
                <CheckCircle className="w-4 h-4 text-green-500 mr-3" />
                Selfie verification
              </li>
              <li className="flex items-center text-sm text-gray-600">
                <CheckCircle className="w-4 h-4 text-green-500 mr-3" />
                Address proof
              </li>
            </ul>
          </div>

          <div className="bg-blue-50 rounded-xl p-4 mb-8">
            <p className="text-sm text-blue-800">
              <span className="font-medium">Your data is secure.</span> You can view or 
              revoke access to your verification at any time from your profile.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/profile')}
              className="btn-primary"
            >
              <Eye className="w-5 h-5 mr-2" />
              View My Profile
            </button>

            <button
              onClick={() => {}}
              className="btn-outline"
            >
              <Share2 className="w-5 h-5 mr-2" />
              Share Verification
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-6 bg-white border-t border-gray-200 safe-area-bottom">
        <button
          onClick={() => navigate('/')}
          className="w-full flex items-center justify-center text-gray-600 font-medium"
        >
          <Home className="w-5 h-5 mr-2" />
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default Completion;
